import React from 'react';
import { Card, CardContent, Typography, Box, List, ListItem } from '@mui/material';
import './GreenLights.css';

const GreenLights = ({ greenFlags }) => {
  const flags = greenFlags && Array.isArray(greenFlags) ? greenFlags : [];

  return (
    <Card 
      className="component-green-light" 
      sx={{ borderRadius: "12px", boxShadow: "none", border: "none" }}
    >
      <CardContent className="header">
        <Typography className="title">
          Green Lights
        </Typography>
      </CardContent>
      <CardContent className="content">
        <List>
          {flags.length > 0 ? (
            flags.map((item, index) => (
              <ListItem key={index} className="list-item">
                <Box className="list-text">
                  <Box className="top-row">
                    <Typography component="div" className="positive_aspect">
                      {item.positive_aspect
                        .replace(/\band\b/g, '&')
                        .split(' ')
                        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                        .join(' ')}
                    </Typography>
                    <Box className="timestamp-container">
                      <Typography className="timestamp">
                        {item.timestamp ? `Timestamp: ${item.timestamp}` : 'No timestamp'}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography component="div" className="list-details">
                    {item.context}
                  </Typography>
                </Box>
              </ListItem>
            ))
          ) : (
            <Typography className="no-scores">
              No green lights detected
            </Typography>
          )}
        </List>
      </CardContent>
    </Card>
  );
};

export default GreenLights;